
// import React, { useState } from 'react';
// import {
//   Box,
//   Avatar,
//   IconButton,
//   Menu,
//   MenuItem,
//   ListItemIcon,
//   Divider,
//   useTheme,
// } from '@mui/material';
// import MenuIcon from '@mui/icons-material/Menu';
// import Logout from '@mui/icons-material/Logout';
// import Person from '@mui/icons-material/Person';

// const Navbar = ({ role, toggleSidebar }) => {
//   const user = JSON.parse(localStorage.getItem('user')) || {};
//   const profileImage = user.profileImage || 'https://via.placeholder.com/36';
//   const theme = useTheme();

//   // State for dropdown menu
//   const [anchorEl, setAnchorEl] = useState(null);
//   const open = Boolean(anchorEl);

//   const handleAvatarClick = (event) => {
//     setAnchorEl(event.currentTarget);
//   };

//   const handleClose = () => {
//     setAnchorEl(null);
//   };

//   const handleLogout = () => {
//     localStorage.removeItem('user');
//     window.location.href = '/'; // redirect to login
//   };

//   const handleProfile = () => {
//     // You can replace this with actual profile route
//     alert('Go to profile page');
//     handleClose();
//   };

//   return (
//     <Box
//       sx={{
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'space-between',
//         px: 2,
//         height: 64,
//         backgroundColor: '#91dfd8ff',
//       }}
//     >
//       <IconButton
//         onClick={toggleSidebar}
//         sx={{ color: theme.palette.common.white, display: { md: 'none' } }}
//       >
//         <MenuIcon />
//       </IconButton>

//       <Box sx={{ fontWeight: 'bold', fontSize: 20 }}>
    
//       </Box>

//       <Box>
//         <IconButton onClick={handleAvatarClick}>
//           <Avatar
//             src={profileImage}
//             sx={{ width: 36, height: 36, border: '2px solid white' }}
//           />
//         </IconButton>
//         <Menu
//           anchorEl={anchorEl}
//           open={open}
//           onClose={handleClose}
//           onClick={handleClose}
//           PaperProps={{
//             elevation: 4,
//             sx: {
//               mt: 1.5,
//               minWidth: 150,
//               overflow: 'visible',
//               filter: 'drop-shadow(0px 4px 10px rgba(0,0,0,0.1))',
//               '&:before': {
//                 content: '""',
//                 display: 'block',
//                 position: 'absolute',
//                 top: 0,
//                 right: 16,
//                 width: 10,
//                 height: 10,
//                 bgcolor: 'background.paper',
//                 transform: 'translateY(-50%) rotate(45deg)',
//                 zIndex: 0,
//               },
//             },
//           }}
//           transformOrigin={{ horizontal: 'right', vertical: 'top' }}
//           anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
//         >
//           <MenuItem onClick={handleProfile}>
//             <ListItemIcon>
//               <Person fontSize="small" />
//             </ListItemIcon>
//             Profile
//           </MenuItem>
//           <Divider />
//           <MenuItem onClick={handleLogout}>
//             <ListItemIcon>
//               <Logout fontSize="small" />
//             </ListItemIcon>
//             Logout
//           </MenuItem>
//         </Menu>
//       </Box>
//     </Box>
//   );
// };

// export default Navbar;


import React, { useState } from 'react';
import {
  Box,
  Avatar,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  Divider,
  Typography,
  useTheme,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import Logout from '@mui/icons-material/Logout';
import Person from '@mui/icons-material/Person';

const Navbar = ({ role = 'User', toggleSidebar }) => {
  const theme = useTheme();
  const user = JSON.parse(localStorage.getItem('user')) || {};
  const profileImage = user?.profileImage || 'https://via.placeholder.com/36';

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    localStorage.removeItem('user');
    window.location.href = '/'; // redirect to login
  };

  const handleProfile = () => {
    alert('Redirect to profile page');
    handleClose();
  };

  return (
    <Box
      // sx={{
      //   display: 'flex',
      //   alignItems: 'center',
      //   justifyContent: 'space-between',
      //   px: 2,
      //   height: 64,
      //   backgroundColor: '#91dfd8ff',
      //   color: theme.palette.common.white,
      // }}

      sx={{
           position: 'fixed', // <-- ye add karo
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1100,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    px: 2,
    height: 64,
    backgroundColor: '#dcf2fd',
    color: theme.palette.common.white,
    
      }}
    >
      {/* Sidebar Toggle (Mobile) */}
      <IconButton
        onClick={toggleSidebar}
        sx={{ color: 'white', display: { md: 'none' } }}
      >
        <MenuIcon />
      </IconButton>

      {/* App Title and Role */}
      <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
        EMS ({role})
      </Typography>

      {/* Avatar & Dropdown Menu */}
      <Box>
        <IconButton onClick={handleAvatarClick}>
          <Avatar
            src={profileImage}
            sx={{
              width: 36,
              height: 36,
              border: '2px solid white',
              bgcolor: 'secondary.main',
            }}
          />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          PaperProps={{
            elevation: 4,
            sx: {
              mt: 1.5,
              minWidth: 150,
              overflow: 'visible',
              filter: 'drop-shadow(0px 4px 10px rgba(0,0,0,0.1))',
              '&:before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 16,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          <MenuItem onClick={handleProfile}>
            <ListItemIcon>
              <Person fontSize="small" />
            </ListItemIcon>
            Profile
          </MenuItem>
          <Divider />
          <MenuItem onClick={handleLogout}>
            <ListItemIcon>
              <Logout fontSize="small" />
            </ListItemIcon>
            Logout
          </MenuItem>
        </Menu>
      </Box>
    </Box>
  );
};

export default Navbar;
